import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import { ContextBuilder } from '../../../../context/builder/reducers';
import Input from '../Input';
import TextArea from '../TextArea';

const VacancyTextBlock = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {title: '', subTitle: '', description: '', img: null };
            dispatch({ type: 'data', payload: { data: data } });
        }
    });

    return (
        <div className="about-us">
            <h2>Vacancy text block</h2>
            <div className="form-group">
                <label>Title</label>
                <Input name="title" value={props.content.title || ''} onChange={onChange}/>
            </div>
            <div className="form-group">
                <label>SubTitle</label>
                <Input name="subTitle" value={props.content.subTitle || ''} onChange={onChange}/>
            </div>
            <div className="form-group">
                <label>Description</label>
                <TextArea name="description" value={props.content.description || ''} onChange={onChange} />
            </div>

        </div>
    );
}

export default VacancyTextBlock;
